module.exports = __webpack_public_path__ + "static/img/img_13.83d9d285.png";